var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',_vm._l((_vm.tags),function(tag,index){return _c('div',{key:index,staticClass:"flex mx-2 leading-5 bg-gray-400 rounded-full"},[_c('button',{staticClass:"flex inline-flex items-center justify-center w-full px-6 py-2 text-base font-medium leading-5 rounded-full focus:outline-none",class:{
                'bg-gray-400  text-gray-700': !tag.isChecked,
                'bg-blue-600 text-white': tag.isChecked
            },on:{"click":function($event){return _vm.updateValue(tag.title)}}},[_vm._v(" "+_vm._s(tag.title)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }